import { Path } from '../../models'

import { isSamePath } from './isSamePath'

export const isOwnerPath = isSamePath(Path.Owner)
